import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Lock = (props: Icon): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 16 16"
    style={{ ...style(props.size, props.height), ...props.style }}
    className={props.className}
  >
    <defs>
      <path
        id="lock-a"
        d="M11.333 4a3.334 3.334 0 013.33 3.189l.004.144V8a.667.667 0 01-1.33.078L13.334 8v-.667a2 2 0 00-1.882-1.996l-.118-.004h-.666A2 2 0 008.67 7.216l-.003.117v.922l7.631 3.815c.2.1.336.294.363.513l.006.084v6.666a.667.667 0 01-.59.663L16 20H8a.667.667 0 01-.662-.589l-.005-.078v-12a3.334 3.334 0 013.19-3.33L10.666 4h.666zM8.667 9.745v8.922h6.666v-5.588L8.667 9.745zM12 12.667A2.667 2.667 0 1112 18a2.667 2.667 0 010-5.333zm1.288 2.322l-1.633 1.633a1.335 1.335 0 001.633-1.633zM12 14a1.333 1.333 0 00-1.288 1.678l1.632-1.633A1.335 1.335 0 0012 14z"
      ></path>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(-7 -4)">
      <mask id="lock-b" fill="#fff">
        <use xlinkHref="#lock-a"></use>
      </mask>
      <g fill={props.color || theme.palette.grey600} mask="url(#lock-b)">
        <path d="M0 0h24v24H0z"></path>
      </g>
    </g>
  </svg>
);
